import { applyMiddleware, combineReducers, createStore } from 'redux';
import createDebounce from 'redux-debounced';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import thunk from 'redux-thunk';
import api from './middlewares/api.js';
import * as reducers from './modules/index.js';
import { SIGN_OUT_SUCCESS } from './modules/auth.js';

const getInitialState = () => {
  const apiUrl = process.env.API_SERVER;
  const surveyjsKey = process.env.SURVEY_JS_LICENSE_KEY;

  if (!apiUrl) {
    throw new Error('API_SERVER environment variable must be defined!');
  }
  if (!surveyjsKey) {
    throw new Error(
      'SURVEY_JS_LICENSE_KEY environment variable must be defined!'
    );
  }

  return {
    config: {
      apiUrl,
      surveyjsKey,
    },
  };
};

const appReducer = combineReducers({
  config: (state = {}) => state,
  ...reducers,
});

const rootReducer = (state, action) => {
  // Reset state to initialState upon sign out
  // See https://stackoverflow.com/q/35622588/956688
  if (action.type === SIGN_OUT_SUCCESS) {
    // Do not reset config state
    state = { config: state.config };
  }

  return appReducer(state, action);
};

// Create store for client-side only (no SSR)
const store = createStore(
  rootReducer,
  getInitialState(),
  composeWithDevTools(applyMiddleware(createDebounce(), thunk, api))
);

export default store;
